var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    [
      _vm.dto.head
        ? [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.dto.head) } }),
            _c("br"),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.dto.trunk
        ? [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.dto.trunk) } }),
            _c("br"),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.dto.member
        ? [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.dto.member) } }),
            _c("br"),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }